export const COLLAPSE_ALL_GROUPS = 'COLLAPSE_ALL_GROUPS';
export const COLLAPSE_ALL_MATCHES = 'COLLAPSE_ALL_MATCHES';



// WEBPACK FOOTER //
// ./js/actions/Collapse.js